import { getServeConfig } from "@/stores/useEnvConfigStore";
import type { FetchLike, WretchOptions } from "wretch";

const localeMiddleware = (next: FetchLike) => async (url: string, opts: WretchOptions) => {
  const locale = localStorage.getItem("lang");
  const { defaultLocale } = getServeConfig();

  opts.headers = {
    ...opts.headers,
    "X-Lang": locale || defaultLocale,
  };

  return next(url, opts);
};

export default localeMiddleware;
